// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.

var selectize_product_fields = () => $('input[name*="product_request[suppliers]"]').selectize({
  valueField: 'id',
  labelField: 'text',
  searchField: 'text',
  create: false,
  maxItems: 1,
  options: $('[data-suppliers]').data('suppliers'),
  onInitialize: function(){
    var errorContainerId = this.$control_input.attr('id')+'-selectize-error';

    $("<div id="+errorContainerId+">").appendTo(this.$wrapper);
    this.$control_input.attr("data-parsley-errors-container", "#"+errorContainerId)
  },
  render: {
    option: function(item, escape) {
        return `<div class="with-avatar">
        <div class="avatar avatar-s">
          <img src="${item.image}" />
        </div>
        <span>${item.text}</span>
      </div>`;
    }
  },
  preload: true,
  load: function(query, callback){
    $.ajax('/companies/auto_complete_search?state=approved', {
      type: 'get',
      data: {
        q: query
      },
      success: function(res) {
        callback(res);
      }
    })
  }
})

$(document).ready(function() {
  if($('#product_request_currency').length > 0){
    $('#product_request_currency').selectize({})
  }

  $(document).on('change', '#product_request_import_file', function() {
    $('.filename#import_filename').html($("input[type='file'][id$='product_request_import_file']")[0].files[0].name).removeClass('hide');
    $('#import_filename').removeClass('hide');
    $('#remove_file').removeClass('hide');
    return $('#remove_file').addClass('show');
  });

  $(document).on('click', '#remove_import_file', function() {
    $("#product_request_import_file").val("");
    $('.filename#import_filename').html("").addClass('hide');
    $('#remove_file').removeClass('show');
    return $('#remove_file').addClass('hide');
  });

  var addRow, hideRemoveButton, removeRow;
  addRow = function(ev) {
    var $nearest_row, $new_row, $remove_button;
    ev.preventDefault();
    $nearest_row = $(this).parent('.text-array__add').prev();
    $nearest_row.find('.text-array__remove').show();
    $new_row = $nearest_row.clone();
    $new_row.find('.selectize-control').remove()
    $new_row.find('input').show();
    $new_row.find('input').val("");
    $new_row.find('input').html("");
    $remove_button = $new_row.find('.text-array-link__remove');
    $remove_button.click(removeRow);
    $new_row.insertBefore($(this).parent('.text-array__add'))

    return selectize_product_fields();
  };
  removeRow = function(ev) {
    ev.preventDefault();
    $(this).closest('.text-array__row').remove();
    return hideRemoveButton();
  };
  hideRemoveButton = function() {
    return $('.text-array').each(function(i, el) {
      var $rows;
      $rows = $(el).children('.text-array__row');
      if ($rows.length === 1) {
        return $rows.find('.text-array__remove').hide();
      }
    });
  };
  $('a.text-array-link__add').click(addRow);
  $('a.text-array-link__remove').click(removeRow);
  selectize_product_fields();
  return hideRemoveButton();
});
